import { atomWithReset } from 'jotai/utils'

import { type Brand, type Question } from '~/hooks/useSurveyQuery'
import { type DataDisplayType, type SegmentDisplayType } from '~/utils'

export const dataDisplayTypeAtom = atomWithReset<DataDisplayType>('percentage')
export const segmentDisplayTypeAtom =
  atomWithReset<SegmentDisplayType>('nineSegs')
export const brandIdsAtom = atomWithReset<Brand['id'][]>([])
export const tabulatedBrandIdsAtom = atomWithReset<Brand['id'][]>([])
export const npiDriverQuestionIdAtom = atomWithReset<
  Question['question_id'] | null
>(null)
export const importanceQuestionIdAtom = atomWithReset<
  Question['question_id'] | null
>(null)
export const liftSaQuestionIdAtom = atomWithReset<
  Question['question_id'] | null
>(null)
export const selectedRouteAtom = atomWithReset<{
  fromSegmentNumber: number
  toSegmentNumber: number
} | null>(null)
export const pendingScrollHashAtom = atomWithReset<string | null>(null)
// キーは buildCommentKey() が組み立てる `${segmentDisplayType}-${from}-${to}`。
// セグマップ・矢印(始点終点セグメント)の組み合わせごとに独立して保持する。
export const commentByViewKeyAtom = atomWithReset<
  Partial<Record<string, string>>
>({})
export const savedCommentByViewKeyAtom = atomWithReset<
  Partial<Record<string, string>>
>({})
